import { ROLES } from '@/constants/roles';

const routes = [
  {
    path: '/qualifications',
    name: 'qualifications',
    component: () => import('./views/Qualifications/index.vue'),
    meta: {
      title: 'Заявочные этапы',
      accessList: [ROLES.certificate, ROLES.member],
      instruction: {
        id: { [ROLES.organization]: 5, [ROLES.member]: 6, [ROLES.certificate]: 6 },
        name: 'Отправка конкурсной работы',
      },
    },
  },
  {
    path: '/qualification/event/view/:id',
    name: 'qualification-event-view-id',
    component: () => import('./views/QualificationEvent/index.vue'),
    meta: {
      title: 'Заявочный этап',
      accessList: [ROLES.certificate, ROLES.member],
      instruction: {
        id: 6,
        name: 'Отправка конкурсной работы',
      },
    },
  },
  {
    path: '/qualification/:id',
    name: 'qualification-id',
    component: () => import('./views/Qualification/index.vue'),
    meta: {
      title: 'Заявочные этапы',
      accessList: [ROLES.certificate, ROLES.member, ROLES.organization],
    },
  },
];

export default routes;
